import { ClientFormInput, ClientFormInputWithToAgencyInput } from 'src/types';

export type SuccessInStoreSubmit = {
  clientOrderId: string;
  tel: string;
};
export type InStoreAgencyInfo = {
  name: string;
  slug: string;
  tel: string;
  address: string;
  zip?: string;
  city: {
    name: string;
    country: {
      name: string;
    };
  };
};

export type InStoreSubmitDataState = {
  isLoading: boolean;
  error: Error | null;
  success: SuccessInStoreSubmit | null;
};

export type InStoreClientRequestForm = {
  sender: ClientFormInput;
  receiver: ClientFormInput;
  senderIsNotReceiver: boolean;
  colisNumber: number;
  description: string;
  toAgency: string;
};

export type InStoreInitialState = {
  agency: InStoreAgencyState;
  form: InStoreClientRequestForm;
  submitData: InStoreSubmitDataState;
  marketingAgencyId?: string;
};

export type InStoreAgencyState = {
  isLoading: boolean;
  error: Error | null;
  info: InStoreAgencyInfo | null;
  agencies: InStoreAgencyInfo[];
};

export type InStoreSetAgencyLoader = {
  isLoading: boolean;
};

export type InStoreSetAgencyError = {
  error: Error | null;
};

export type InStoreSetAgencyInfo = {
  info: InStoreAgencyInfo | null;
};

export type InStoreSetAgenciesList = {
  agencies: InStoreAgencyInfo[];
};

export const START_LOADING_IN_STORE_AGENCY_INFO = 'inStore/start/loadingAgency';

export const IN_STORE_SUBMIT_DATA_INFO = 'inStore/start/submit/data/info';
export const HOME_TO_STORE_SUBMIT_DATA_INFO = 'home/to/store/start/submit/data/info';

export type InStoreStartLoadingAgencyInfoAction = {
  type: typeof START_LOADING_IN_STORE_AGENCY_INFO;
  slug: string;
};

export type InStoreStartSubmitFormData = {
  type: typeof IN_STORE_SUBMIT_DATA_INFO;
};
export type HomeToStoreStartSubmitFormData = {
  type: typeof HOME_TO_STORE_SUBMIT_DATA_INFO;
};

export type SetInStoreSenderAction = {
  sender: ClientFormInputWithToAgencyInput;
};

export type SetInStoreReceiverAction = {
  receiver: ClientFormInput;
};

export type SetInStoreSenderIsNotReceiverAction = {
  senderIsNotReceiver: boolean;
};

export type SetInStoreColisNumberAndDescriptionAction = {
  colisNumber: number;
  description: string;
};

export type SetInStoreSubmitDataSetLoaderAction = {
  isLoading: boolean;
};

export type SetInStoreSubmitDataSetErrorAction = {
  error: Error | null;
};

export type SetInStoreSubmitDataSetSuccessAction = {
  success: SuccessInStoreSubmit | null;
};
